<template>
  <div>
     <vue-headful
            title="Girish Jewellers online shop for golden ornaments like bangles, bracelets, golden sets,pandent set, rings, wedding bands"
            description="Girish Jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>
          <MainBanner msg="Welcome to Your Vue.js App"  />
          
          <BannerSet msg="Welcome to Your Vue.js App"/>
          <div class="clearfix"></div>

          
      
          <section id="main">
             <div class="container">
               <WhoWeAre msg="Welcome to Your Vue.js App"/>
               
              <BestSellers msg="Welcome to Your Vue.js App"/>
             </div>
          </section>


          
        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile"/>
    </div>
</template>

<script>
// @ is an alias to /src

import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import MainBanner from '@/components/MainBanner.vue'
import BannerSet from '@/components/BannerSet.vue'
import BestSellers from '@/components/BestSellers.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import WhoWeAre from '@/components/WhoWeAre.vue'
import Common from '@/common.js'
import Vue from 'vue'
import VueMeta from 'vue-meta'
import vueHeadful from 'vue-headful';

Vue.use(VueMeta);


export default {
  name: 'home',
    metaInfo() {
      return { 
          meta: [
              { name: 'og:description', content:  'Girish Jewellers is the jewellery shop having varity of design for ornaments like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india.'},
              { property: 'og:title', content: "Home - Girish Jewellers"},
              { property: 'og:site_name', content: 'Girish Jewellers'},
              {property: 'og:type', content: 'Jewellery Products'},    
              {name: 'robots', content: 'index,follow'} 
          ]}
      },
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    MainBanner,
    BannerSet,
    BestSellers,
    WhoWeAre,
    FooterWeb,
    Footer    
  },
   mounted:function(){
      this.loadOnMount();
  },
   data:function(){
      return {};
  },
  computed:{
    isMobile:function(){
    return Common.isMobile();
    }
  },
  methods:{

      onResize: function() {
    },
      loadOnMount: function() {
        $.get('js/main.js', function(data) {
        eval(data);
   //process text file line by line
   //$('#div').html(data.replace('n',''));
});
      }

  }
  
}
</script>
